import { useQuery } from '@tanstack/react-query';
import { fetchTableRows, fetchTableInfo, type RowsParams } from '../api/mysql';

export function useTableData(db: string | null, table: string | null, params: RowsParams) {
  return useQuery({
    queryKey: ['mysql', 'rows', db, table, params],
    queryFn: () => fetchTableRows(db!, table!, params),
    enabled: !!db && !!table,
    placeholderData: (prev) => prev,
  });
}

export function useTableInfo(db: string | null, table: string | null) {
  return useQuery({
    queryKey: ['mysql', 'info', db, table],
    queryFn: () => fetchTableInfo(db!, table!),
    enabled: !!db && !!table,
  });
}
